import Ruc from './Ruc';

export const isClientEnv = () => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export const currentYear = (): number => new Date().getFullYear();

export const required = (value: string) => {
  return value ? null : 'Campo requerido';
}

export const email = (value: string) => {
  return !/(\.{2}|-{2}|_{2})/.test(value) && /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/i.test(value) ? null : 'Ingrese un email válido';
};

const minLength = (number: number) => (value: string) => {
  return value.length >= number ? null : `Ingrese mínimo ${number} caracteres`;
}

export const minLength2 = minLength(2);
export const minLength3 = minLength(3);
export const minLength4 = minLength(4);
export const minLength6 = minLength(6);

export const onlyLetters = (value: string) => {
  return /^[a-zA-Z\u0080-\u024F\s\)\(\`\"\'\‘\’\”\“]+$/gi.test(value) ? null : 'Por favor, ingrese solo letras';
};

export const ruc = (value: string): string => Ruc.isValid(value) ? null : 'Ruc inválido';

export const dni = (value: string): string => value && value.length === 8 ? null : 'Dni inválido';

export const isBelongToIntervalNumber = (min: number, max: number) => (value: string) => Number(value) >= min && Number(value) <= max ? null : `Año inválido(${min} - ${max})`;

export const isBetween1920And2022 = isBelongToIntervalNumber(1920, 2022);
